module.exports = __webpack_public_path__ + "static/media/hu.2e0e3e50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hu.svg
// module id = 145
// module chunks = 0